import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Plus } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

const B = process.env.REACT_APP_BACKEND_URL;

const Row = ({ c, onToggle, onLabel, main }) => (
  <div className="flex items-center gap-2 rounded-lg border border-zinc-800 p-1.5" data-testid={`color-${main ? "main" : c.id}`}>
    {main ? <span className="w-4" /> : <Checkbox data-testid={`color-toggle-${c.id}`} checked={c.enabled} onCheckedChange={onToggle} className="border-zinc-600 data-[state=checked]:bg-amber-400 data-[state=checked]:text-zinc-950" />}
    {c.image && <img src={c.image} alt="" className="h-9 w-9 rounded bg-white object-contain" />}
    <Input data-testid={`color-label-${main ? "main" : c.id}`} value={c.label || ""} onChange={(e) => onLabel(e.target.value)} placeholder="Culoare" className="h-7 w-28 text-xs" />
    <span className="flex-1 truncate text-[11px] text-zinc-500">{c.sku} · {c.price} lei</span>
    {main ? <span className="text-[10px] text-amber-300">principal</span> : !c.in_stock && <span className="text-[10px] text-rose-300">fără stoc — ascuns</span>}
  </div>
);

export const ColorList = ({ d, setD }) => {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [found, setFound] = useState([]);
  useEffect(() => { axios.get(`${B}/api/landing/${d.id}/colors`).then((r) => setData(r.data)).catch(() => setData({ main: null, items: [] })); }, [d.id]);
  useEffect(() => {
    if (q.trim().length < 2) { setFound([]); return; }
    const t = setTimeout(() => axios.get(`${B}/api/creatives/products`, { params: { q } }).then((r) => setFound((r.data.items || []).slice(0, 5))).catch(() => {}), 300);
    return () => clearTimeout(t);
  }, [q]);
  if (!data) return <Loader2 className="h-4 w-4 animate-spin text-zinc-500" />;
  const items = data.items;
  const push = (next, mainLabel) => {
    setData({ ...data, items: next, main: { ...data.main, label: mainLabel ?? data.main?.label } });
    setD({ ...d, colors: next.map((c) => ({ id: c.id, sku: c.sku, label: c.label, enabled: c.enabled })), main_color: mainLabel ?? data.main?.label ?? "" });
  };
  const upd = (i, patch) => push(items.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const add = (p) => { if (p.sku === data.main?.sku || items.some((c) => c.sku === p.sku)) return; push([...items, { id: null, sku: p.sku, label: "", enabled: true, image: p.images?.[0], price: "", in_stock: true }]); setQ(""); };
  return (
    <div className="space-y-2" data-testid="color-list">
      <p className="text-xs text-zinc-500">Culorile apar lângă preț. Clientul alege culoarea, iar poza și butoanele de comandă trec pe produsul ales. Debifează ce nu vrei să apară.</p>
      {data.main && <Row c={data.main} main onLabel={(v) => push(items, v)} />}
      {items.map((c, i) => <Row key={c.sku} c={c} onToggle={(v) => upd(i, { enabled: !!v })} onLabel={(v) => upd(i, { label: v })} />)}
      {items.length === 0 && <p className="text-xs text-zinc-500" data-testid="color-empty">Nu am găsit alte culori ale acestui produs în Shopify. Le poți adăuga mai jos.</p>}
      <div className="relative">
        <Input data-testid="color-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Adaugă altă culoare: caută produsul în Shopify…" className="h-8 text-xs" />
        {found.length > 0 && <div className="absolute z-10 mt-1 w-full rounded-lg border border-zinc-700 bg-zinc-900 p-1">
          {found.map((p) => <button key={p.sku} data-testid={`color-add-${p.sku}`} onClick={() => add(p)} className="flex w-full items-center gap-2 rounded px-2 py-1 text-left text-xs text-zinc-200 hover:bg-zinc-800"><Plus className="h-3 w-3" /><span className="truncate">{p.title}</span></button>)}
        </div>}
      </div>
      <p className="text-[11px] text-zinc-500">Apasă „Salvează” ca să apară în previzualizare.</p>
    </div>
  );
};
